import Cookies from 'js-cookie'

const TokenKey = 'user-token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setUserInfo(data) {
  let data2 = JSON.stringify(data);
  if(typeof(data.token) != 'undefined'){
    setToken(data.token)

  }
  return Cookies.set("userInfo",data2)
}

export function getUserInfo() {
  let userinfo =  Cookies.get("userInfo")
  if(typeof(userinfo)=='undefined'){
    return {
        username : '',
        score : 0,
        nickname : '',
        token : '',
        id : '',
        withdraw_price : 0,
        freeze_withdraw_price : 0
      
    }
  }
  return JSON.parse(userinfo)
}

export function removeUserInfo() {
  removeToken();
  return Cookies.remove("userInfo")
}